module.exports = __webpack_public_path__ + "static/media/foto12.ed275f02.png";